<template>
  <div>
    <BusinessTransactionForm
      v-if="!fetchingTransactionTypes && !fetchingWallet"
      :transaction-type="transactionType"
      :is-side-bar-active.sync="isAddMoneyBarActive"
      :transaction-types="transactionTypes"
      :wallet-id="walletId"
      @transaction-saved="()=> {
        fetchBusinessTransactions()
        fetchWallet()
      }"
    />
    <base-overlay
      :show="fetchingWallet"
    >
      <b-card
        no-body
        class="p-1"
      >
        <b-row>
          <b-col
            md="4"
            class="d-flex align-items-center"
          >
            <div class="d-flex align-items-center">
              <feather-icon
                icon="DollarSignIcon"
                class="mr-75"
              />
              <span class="font-weight-bold mr-1">Balance:</span>
              {{ balanceValue }}

            </div>
          </b-col>
          <b-col
            md="4"
            class="d-flex align-items-center"
          >
            <div class="d-flex align-items-center">
              <feather-icon
                icon="DollarSignIcon"
                class="mr-75"
              />
              <span class="font-weight-bold mr-1">Pending Balance:</span>
              {{ pendingBalanceValue }}

            </div>
          </b-col>
        </b-row>
      </b-card>
    </base-overlay>
    <b-card>
      <div class="d-flex justify-content-end align-items-center">
        <h2>Transactions History</h2>
        <v-select
          v-model="queryParams.transaction_type_id"
          style="flex:1"
          class="mx-1"
          :options="transactionTypes"
          :loading="fetchingTransactionTypes"
          option-label="label"
          :reduce="val => val.id"
          placeholder="Search by account name"
        />
        <b-button
          class="mr-1"
          variant="outline-primary"
          @click="fetchBusinessTransactions"
        >
          Search
        </b-button>
        <b-button
          variant="success"
          class="mr-2"
          :disabled="fetchingTransactionTypes"
          @click="selectTransaction('add')"
        >
          Add Money
        </b-button>
        <b-button
          variant="primary"
          class="mr-2"
          :disabled="fetchingTransactionTypes"
          @click="selectTransaction('deduct')"
        >
          Deduct Money
        </b-button>

      </div>

      <base-overlay :show="fetchingTransactions">
        <b-table
          responsive
          :items="businessTransactions"
          :fields="tableColumns"
          show-empty
          empty-text="No transactions found"
          class="mt-2"
        >
          <template #cell(created_at)="data">
            {{ `${data.item.created_at}Z` | formatDate }}
          </template>

        </b-table>
        <base-pagination
          v-model="queryParams.page"
          :total="totalTransactions"
          @new-per-page="queryParams.size = $event"
        />
      </base-overlay>
    </b-card>

  </div>
</template>

<script>
import {
  reactive, ref, watch, toRef,
} from '@vue/composition-api'
import {
  BCard, BTable, BButton, BRow, BCol,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import BasePagination from '@/UI/BasePagination.vue'
import BusinessTransactionForm from './BusinessTransactionForm.vue'
import transactionTypesStore from '@/views/billing/transaction-types/transactionTypesStore'
import useRegisterStoreModule from '@/hooks/useRegisterStoreModule'
import BaseOverlay from '@/UI/BaseOverlay.vue'

export default {
  components: {
    BCard, BasePagination, BTable, BButton, BusinessTransactionForm, vSelect, BaseOverlay, BRow, BCol,
  },
  setup(props, ctx) {
    useRegisterStoreModule('transaction-types', transactionTypesStore)
    const transactionTypes = ref([])
    const fetchingTransactionTypes = ref(false)

    const fetchTransactionTypes = async () => {
      fetchingTransactionTypes.value = true
      transactionTypes.value = await ctx.root.$store.dispatch('transaction-types/fetchTransactionTypes')
      fetchingTransactionTypes.value = false
    }

    const businessId = ctx.root.$route.params.id
    const walletId = ref(null)
    const balanceValue = ref(0)
    const pendingBalanceValue = ref(0)
    const businessTransactions = ref([])
    const totalTransactions = ref(0)
    const isAddMoneyBarActive = ref(false)
    const transactionType = ref('')
    const selectTransaction = type => {
      transactionType.value = type
      isAddMoneyBarActive.value = true
    }
    const tableColumns = [
      { key: 'created_at', label: 'Date/Time' },
      { key: 'transaction_type_label', label: 'Account Name' },
      { key: 'credit_amount', label: 'Credit' },
      { key: 'debit_amount', label: 'Debit' },
      { key: 'added_by', label: 'Added By' },
      { key: 'remark_text', label: 'Remark' },
    ]
    const queryParams = reactive({
      page: 1,
      size: 10,
      transaction_type_id: null,
    })

    const fetchingWallet = ref(false)
    const fetchWallet = async () => {
      fetchingWallet.value = true
      const res = await ctx.root.$store.dispatch('business/getBusinessWallet', businessId)
      const { id, balance, pendingBalance } = res.data.data
      balanceValue.value = balance
      pendingBalanceValue.value = pendingBalance
      walletId.value = id
      fetchingWallet.value = false
      console.log('res', res)
    }

    const fetchingTransactions = ref(false)
    const fetchBusinessTransactions = async () => {
      fetchingTransactions.value = true
      const res = await ctx.root.$store.dispatch('business/getBusinessWalletTransactions', {
        walletId: walletId.value,
        params: queryParams,
      })
      const { total, transactions } = res.data.data
      businessTransactions.value = transactions
      totalTransactions.value = total
      fetchingTransactions.value = false
    }
    watch([toRef(queryParams, 'page'), toRef(queryParams, 'size')], () => {
      fetchBusinessTransactions()
    })
    const init = async () => {
      await fetchWallet()
      fetchBusinessTransactions()
    }

    init()
    fetchTransactionTypes()

    return {
      balanceValue,
      queryParams,
      transactionType,
      init,
      selectTransaction,
      tableColumns,
      isAddMoneyBarActive,
      pendingBalanceValue,
      businessTransactions,
      fetchingWallet,
      fetchingTransactions,
      transactionTypes,
      totalTransactions,
      fetchBusinessTransactions,
      fetchingTransactionTypes,
      walletId,
      fetchWallet,
    }
  },
}
</script>

<style>

</style>
